export const TAGS = [
    // Design Styles
    "Modern",
    "Minimalist",
    "Vintage",
    "Retro",
    "Abstract",
    "Geometric",
    "Elegant",
    "Rustic",
    "Professional",
    "Playful",

    // Colors
    "Colorful",
    "Monochrome",
    "Pastel",
    "Dark",
    "Light",
    "Vibrant",

    // Elements
    "Photo",
    "Typography",
    "Illustration",
    "Icons",
    "Pattern",
    "Border",
    "Frame",

    // Themes
    "Nature",
    "Food",
    "Fashion",
    "Technology",
    "Music",
    "Sports",
    "Travel",
    "Education",
    "Health",
    "Beauty",

    // Occasions
    "Holiday",
    "Seasonal",
    "Festival",
    "Corporate",
    "Casual",
    "Formal",

    // Formats
    "Square",
    "Portrait",
    "Landscape",
    "Story",
    "Banner",
    "Cover",
    "Post",

    // Features
    "Editable",
    "Customizable",
    "Animated",
    "Static",
    "Premium",
    "Free"
]